module.exports = __webpack_public_path__ + "./images/fuel tank.svg?1515593a2c95abd979fea3d761ba563b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fuel tank.svg
// module id = 84
// module chunks = 0